class Top {
  constructor(el,opt){
    this.el = el;
    this.mvSwiper = null;
    this.worksSwiper = null;
    this.worksMq = window.matchMedia('(max-width: 767px)');
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.initMvSlider();
    this.initWorksSlider();
  }

  initMvSlider(){
    const swiperEl = document.querySelector('.js-mv-swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length < 2) return;

    this.mvSwiper = new Swiper(swiperEl, {
      effect: 'fade',
      fadeEffect: {
        // false: 前面がフェードアウトし、裏の画像がふわっと見える
        crossFade: false,
      },
      speed: 4500,
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 1500,
        disableOnInteraction: false,
      },
    });

    // ローディング中は止め、完了後に開始
    this.mvSwiper.autoplay.stop();
    $(window).on('loading', () => {
      if (this.mvSwiper && this.mvSwiper.autoplay) {
        this.mvSwiper.autoplay.start();
      }
    });
  }

  initWorksSlider(){
    const section = document.querySelector('.p-top-works');
    if (!section) return;

    const slider = section.querySelector('.p-top-works__slider');
    const swiperEl = section.querySelector('.js-works-swiper');
    if (!slider || !swiperEl || typeof Swiper === 'undefined') return;

    const count = Number(slider.dataset.count || swiperEl.querySelectorAll('.swiper-slide').length);
    const update = () => {
      const useSwiper = this.worksMq.matches ? count >= 2 : count >= 4;
      if (useSwiper) {
        this.enableWorksSwiper(section, slider, swiperEl);
      } else {
        this.disableWorksSwiper(slider);
      }
    };

    update();
    if (this.worksMq.addEventListener) {
      this.worksMq.addEventListener('change', update);
    } else {
      this.worksMq.addListener(update);
    }
  }

  enableWorksSwiper(section, slider, swiperEl){
    slider.classList.remove('is-grid');
    if (this.worksSwiper) return;

    this.worksSwiper = new Swiper(swiperEl, {
      slidesPerView: 1.6,
      spaceBetween: 16,
      watchOverflow: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: section.querySelector('.js-works-next'),
        prevEl: section.querySelector('.js-works-prev'),
      },
      pagination: {
        el: section.querySelector('.js-works-progress'),
        type: 'progressbar',
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
    });
  }

  disableWorksSwiper(slider){
    if (this.worksSwiper) {
      this.worksSwiper.destroy(true, true);
      this.worksSwiper = null;
    }
    slider.classList.add('is-grid');
  }
}
